import React from "react";

const ErrorPage = () => {
  return <>Error Page</>;
};

export default ErrorPage;
